import { useContext, useEffect, useRef } from 'react'
import { CanvasCtrl } from './CanvasCtrl'
import { DataContext } from '../data/DataContext';
import { IconLeft, IconRigth } from '../img';
import { ConsoleLogger } from '@microsoft/signalr/dist/esm/Utils';


const CarouselCtrl = () => {

    const { ReclamosInspeccionNI, setReclamosInspeccionNI, changeHandler } = useContext(DataContext);
    const ref = useRef<HTMLInputElement>(null);

    const change = (properties: string, newImg: string, isModifiedImg: boolean) => {
        setReclamosInspeccionNI({...ReclamosInspeccionNI, [properties]: {  isModified: isModifiedImg ,value : newImg  } as IImageInspection })
    }


    const prev = (e: any) => {
        e.preventDefault();
        requestAnimationFrame(() => {
            const scrollLeft = ref.current?.scrollLeft ?? 0;
            const itemWidth = parseInt(
                getComputedStyle(ref.current?.children[0] ?? new HTMLElement()).width
            );
            if (ref.current !== null)
                ref.current.scrollLeft = scrollLeft - itemWidth
        });
    };

    const next = (e: any) => {
        e.preventDefault();
        requestAnimationFrame(() => {
            const scrollLeft = ref.current?.scrollLeft ?? 0;
            const itemWidth = parseInt(
                getComputedStyle(ref.current?.children[0] ?? new HTMLElement()).width
            );
            if (ref.current !== null)
                ref.current.scrollLeft = scrollLeft + itemWidth;
        });
    };



    return (
        <>
            <div className='lbl-paso-t1 mt-20'>
                Daños al vehículo asegurado
            </div>
            <div className='lbl-paso-t2 mt-10 mb-20'>
                Marque en la imagen los daños que presenta el vehículo
            </div>
            <div className='slider-container mb-20' ref={ref}>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto1'
                        value={ReclamosInspeccionNI.imgAuto1.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto2'
                        value={ReclamosInspeccionNI.imgAuto2.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto3'
                        value={ReclamosInspeccionNI.imgAuto3.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto4'
                        value={ReclamosInspeccionNI.imgAuto4.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto5'
                        value={ReclamosInspeccionNI.imgAuto5.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto6'
                        value={ReclamosInspeccionNI.imgAuto6.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto7'
                        value={ReclamosInspeccionNI.imgAuto7.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto8'
                        value={ReclamosInspeccionNI.imgAuto8.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto9'
                        value={ReclamosInspeccionNI.imgAuto9.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto10'
                        value={ReclamosInspeccionNI.imgAuto10.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto11'
                        value={ReclamosInspeccionNI.imgAuto11.value}
                        onChange={change}
                    />
                </div>
                <div className='slider-item'>
                    <CanvasCtrl
                        id='imgAuto12'
                        value={ReclamosInspeccionNI.imgAuto12.value}
                        onChange={change}
                    />
                </div>
            </div>
            <div className='mt-10 mb-20' style={{ display: 'flex', justifyContent: 'space-around' }}>
                <button className='slider-back' onClick={prev}> <IconLeft /></button>
                <button className='slider-back' onClick={next}><IconRigth /></button>
            </div>
        </>
    )
}

export { CarouselCtrl }